import React from "react";
import HandymanForms from "./HandymanForms";

const AddHandyman = () => {
    return(
        <HandymanForms type="Add"/>
    )
}

export default AddHandyman